import { Currency } from '../../../types/currency/Currency'

const exchangeRateQueryKeys = {
  all: [{ scope: 'exchangeRate' }] as const,
  default: (from?: Currency, to?: Currency) =>
    [{ ...exchangeRateQueryKeys.all[0], entity: 'default', from, to }] as const,
  lists: () => [{ ...exchangeRateQueryKeys.all[0], entity: 'list' }] as const,
  list: (groupId: string) => [{ ...exchangeRateQueryKeys.lists()[0], groupId }] as const,
  serie: (groupId: string, serieId: string) =>
    [{ ...exchangeRateQueryKeys.all[0], entity: 'serie', groupId, serieId }] as const
}

export default exchangeRateQueryKeys
